module.exports = __webpack_public_path__ + "img/tab_item05.6f834ba7.png";